<script>
import Title from '@components/section-title'
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'
import Vue from 'vue'

export default {
  components: { Title },
  data() {
    return {
      busModal: new Vue(),
    }
  },
  created() {
    GlobalBus.$on(MODAL.CONVERSAO_RATING, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.CONVERSAO_RATING, this.open)
  },
  methods: {
    open() {
      this.busModal.$emit('dialog', true)
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" max-width="900px">
    <Title title="Conversão rating" />
    <div>
      <v-simple-table height="500" fixed-header class="table-rating">
        <thead>
          <tr>
            <th class="bg-light">Fitch</th>
            <th>Moody's</th>
            <th>S&P</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="bg-light">AAA</td>
            <td>Aaa</td>
            <td>AAA</td>
          </tr>
          <tr>
            <td class="bg-light">AA+</td>
            <td>Aa1</td>
            <td>AA+</td>
          </tr>
          <tr>
            <td class="bg-light">AA</td>
            <td>Aa2</td>
            <td>AA</td>
          </tr>
          <tr>
            <td class="bg-light">AA-</td>
            <td>Aa3</td>
            <td>AA-</td>
          </tr>
          <tr>
            <td class="bg-light">A+</td>
            <td>A1</td>
            <td>A+</td>
          </tr>
          <tr>
            <td class="bg-light">A</td>
            <td>A2</td>
            <td>A</td>
          </tr>
          <tr>
            <td class="bg-light">A-</td>
            <td>A3</td>
            <td>A-</td>
          </tr>
          <tr>
            <td class="bg-light">BBB+</td>
            <td>Baa1</td>
            <td>BBB+</td>
          </tr>
          <tr>
            <td class="bg-light">BBB</td>
            <td>Baa2</td>
            <td>BBB</td>
          </tr>
          <tr>
            <td class="bg-light">BBB-</td>
            <td>Baa3</td>
            <td>BBB-</td>
          </tr>
          <tr>
            <td class="bg-light">BB+</td>
            <td>Ba1</td>
            <td>BB+</td>
          </tr>
          <tr>
            <td class="bg-light">BB</td>
            <td>Ba2</td>
            <td>BB</td>
          </tr>
          <tr>
            <td class="bg-light">BB-</td>
            <td>Ba3</td>
            <td>BB-</td>
          </tr>
          <tr>
            <td class="bg-light">B+</td>
            <td>B1</td>
            <td>B+</td>
          </tr>
          <tr>
            <td class="bg-light">B</td>
            <td>B2</td>
            <td>B</td>
          </tr>
          <tr>
            <td class="bg-light">B-</td>
            <td>B3</td>
            <td>B-</td>
          </tr>
          <tr>
            <td class="bg-light" rowspan="5">CCC</td>
            <td>Caa1</td>
            <td>CCC+</td>
          </tr>
          <tr>
            <td>Caa2</td>
            <td>CCC</td>
          </tr>
          <tr>
            <td>Caa3</td>
            <td>CCC-</td>
          </tr>
          <tr>
            <td rowspan="2">Ca</td>
            <td>CC</td>
          </tr>
          <tr>
            <td>C</td>
          </tr>
          <tr>
            <td class="bg-light">DDD</td>
            <td>C</td>
            <td rowspan="3">D</td>
          </tr>
          <tr>
            <td class="bg-light">DD</td>
            <td>/</td>
          </tr>
          <tr>
            <td class="bg-light">D</td>
            <td>/</td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>

    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close">
        Voltar
      </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>

<style lang="sass" scope>
.table-rating tbody
  tr:hover
    background-color: transparent !important
</style>
